import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import campaigns from '@/store/campaigns'
import modules from '@/store/modules'
import app from './app'
import appConfig from './app-config'
import auth from './auth'
import farmers from './farmers'
import shipmentsNowStats from './shipments/nowStats'
import shipmentsNowExpeditionSheets from './shipments/nowExpeditionSheets'
import shipmentsNowDeliveries from './shipments/nowDeliveries'
import shipmentsHistory from './shipments/history'
import server from './server'
import settings from './settings'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    auth,
    farmers,
    modules,
    campaigns,
    shipmentsNowStats,
    shipmentsNowExpeditionSheets,
    shipmentsNowDeliveries,
    shipmentsHistory,
    server,
    settings,
  },
  strict: process.env.DEV,
})
